import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_1taybicqc4: FaireBrandEntity = {
  token: "b_1taybicqc4",
  type: "brand",
  name: "BiBi",
  avatarUrl:
    "https://cdn.faire.com/fastly/7a8c0c2df8704a83d8f5da4bdcaed8a28e77474ef01179587e154663b573c9bb.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/240029082c6b763d4074a77b9025ebaa341d43f48aa00736cd238f5eab2dd55e.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/7a8c0c2df8704a83d8f5da4bdcaed8a28e77474ef01179587e154663b573c9bb.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/240029082c6b763d4074a77b9025ebaa341d43f48aa00736cd238f5eab2dd55e.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 0,
  rating: 4.9,
  reviewCount: 95,
  isTopShop: true,
  isInsider: true,
  description:
    "BiBi was founded in 2018, with its vision of being one of the leaders in women's clothing.\n\nSince its beginning in 2018, we constantly produce a major collection of inspirational pieces that have unique aesthetics and thrill expectations of retailers from all over the U.S.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:54:46.835Z",
    importedBy: "entity-db-cli",
  },
};
